import { render } from "./IntroFourthView.vue?vue&type=template&id=ea38ce2e"
import script from "./IntroFourthView.vue?vue&type=script&lang=js"
export * from "./IntroFourthView.vue?vue&type=script&lang=js"

import "./IntroFourthView.vue?vue&type=style&index=0&id=ea38ce2e&lang=css"

import exportComponent from "C:\\Users\\Emertat\\Desktop\\p\\nazerhelp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__